import { React, useState, useEffect, useContext } from "react";
import Button from "@mui/material/Button";
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import GridNoRow from '../../../../common/GridNoRow';
import axios from "axios";
import Swal from "sweetalert2";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import AuthorityRegModal from "../../../../modal/PC/system/AuthorityRegModal";
import AuthorityUpdateModal from "../../../../modal/PC/system/AuthorityUpdateModal";
import styled from "styled-components";
import Select from 'react-select';
import { AppContext } from '../../../../AppStore';
import Moment from 'moment';
import "moment/locale/ko";
import { useNavigate, useLocation } from "react-router-dom";

const Authority = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const appStore = useContext(AppContext);
    const [MenuID, setMenuID] = useState(0);
    const [MenuName, setMenuName] = useState('');
    const [MenuUpdateExistYN, setMenuUpdateExistYN] = useState('N');
    const [MenuDeleteExistYN, setMenuDeleteExistYN] = useState('N');
    const [MenuUpdateYN, setMenuUpdateYN] = useState('N');
    const [MenuDeleteYN, setMenuDeleteYN] = useState('N');
    const [rows, setRows] = useState([]);
    const [originRows, setOriginRows] = useState([]);
    const [columns, setColumns] = useState([]);
    const [authorityTypeModalOption, setAuthorityTypeModalOption] = useState([]);
    const [authorityTypeOption, setAuthorityTypeOption] = useState([]);
    const [keyword, setKeyword] = useState({
        authority_type: 0,
        search: ''
    });
    const [deptModalOption, setDeptModalOption] = useState([]);
    const [positionModalOption, setPositionModalOption] = useState([]);
    const [dutyModalOption, setDutyModalOption] = useState([]);
    const [isRegModalOpen, setRegModalOpen] = useState(false);
    const [isUpdateModalOpen, setUpdateModalOpen] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [selectAuthorityID, setSelectAuthorityID] = useState('');

    // Grid정의
    const handleSetting = () => {
        setColumns([
            {
                field: 'updated',
                headerName: '수정',
                width: 55,
                type:'actions',
                disableClickEventBubbling: true,
                getActions: (params) => [
                    <GridActionsCellItem icon={<EditIcon color="primary" />} onClick={() => {UpdateClick(params)}} label="Edit" disabled="" />
                ],
                headerAlign: 'center', 
                align:'center'
            },
            {
                field: 'deleted',
                headerName: '삭제',
                width: 55,
                type:'actions',
                disableClickEventBubbling: true,
                getActions: (params) => [
                    <GridActionsCellItem icon={<DeleteIcon color={ MenuDeleteYN === "Y" && params.row.update_flag === 'Y' ? "error" : "grey"} />} onClick={() => {DeleteClick(params)}} label="Delete" disabled={ MenuDeleteYN === "Y" && params.row.update_flag === 'Y'? false : true } />
                ],
                headerAlign: 'center', 
                align:'center'
            },
            { field: 'id', headerName: '권한ID', width: 0, headerAlign: 'center', align:'center' },
            { field: 'authority_type', headerName: 'authority_type', width: 0, headerAlign: 'center', align:'left' },
            { field: 'authority_name', headerName: '권한명', width: 250, headerAlign: 'center', align:'left' },
            { field: 'authority_type_name', headerName: '권한유형', width: 120, headerAlign: 'center', align:'center' },
            { field: 'authority_desc', headerName: '권한설명', width: 400, headerAlign: 'center', align:'left' },
            { field: 'reg_user_id', headerName: 'reg_user_id', width: 0, headerAlign: 'center' },
            { field: 'reg_user_name', headerName: '등록자', width: 120, headerAlign: 'center', align:'center' },
            { field: 'reg_datetime', headerName: '등록일시', width: 180, headerAlign: 'center', align:'center' },
            { field: 'update_user_id', headerName: 'update_user_id', width: 0, headerAlign: 'center' },
            { field: 'update_user_name', headerName: '수정자', width: 120, headerAlign: 'center', align:'center' },
            { field: 'update_datetime', headerName: '수정일시', width: 180, headerAlign: 'center', align:'center' },
        ]);
    }

    const [columnVisibilityModel, setColumnVisibilityModel] = useState({
        id: false,
        authority_type: false,
        authority_name: true,
        authority_type_name: true,
        authority_desc: true,
        reg_user_id: false,
        reg_user_name: true,
        reg_datetime: true,
        update_user_id: false,
        update_user_name: true,
        update_datetime: true,
        deleted: true,
        updated: true
    });

    useEffect(() => {
        const accessList = JSON.parse(localStorage.getItem("nav"));
        
        if (Array.isArray(accessList) && accessList.filter(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).length > 0) {
            setMenuID(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_id);
            setMenuName(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_name);
            setMenuUpdateExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_exist_yn);
            setMenuDeleteExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_exist_yn);
            setMenuUpdateYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_yn);
            setMenuDeleteYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_yn);
        }else{
            Swal.fire({
                title: '<p style="color:red">접근 권한 오류</p>',
                text: '화면에 접근 권한이 없습니다.',
                confirmButtonText: '확인',
                confirmButtonColor: '#7066e0',
                timer:5000,
                timerProgressBar: true
            }).then((value) => {
                return navigate(-1);
            });
        }
    }, []);

    useEffect(() => {
        if(String(MenuID) !== String(0) && MenuID != null){
            handleView();
        }
    }, [keyword.authority_type]);

    useEffect(() => {
        if(String(MenuID) !== String(0) && MenuID != null){
            handleSetting();
            handleInitSelect();
            handleInit();
            handleView();
        }
    }, [MenuID]);

    // Grid 데이터 조회
    const handleView = () => {
        if (appStore.loading) return;
        appStore.setLoading(true);
        
        axios.get('/api/p/Authority/List',
          {
            params : { 
                authority_type: keyword.authority_type,
                search: keyword.search
             }
          },
          { withCredentials: true }
        )
        .then((response) => {
            if(response.status === 200){
                const PermissionMap = {};
                response.data.forEach(row => {
                    if (!PermissionMap[row.authority_id]) {
                        PermissionMap[row.authority_id] = [row.reg_user_id, row.update_user_id].includes(Number(localStorage.getItem('user_id')));
                    }
                });
                
                console.log(response.data)
                const array = response.data.map((item, index) => ({
                    id: item.authority_id,
                    authority_type: item.authority_type,
                    authority_name: item.authority_name,
                    authority_type_name: item.authority_type_name,
                    authority_desc: item.authority_desc,
                    reg_user_id: item.reg_user_id,
                    reg_user_name: item.reg_user_name,
                    reg_datetime: (item.reg_datetime === undefined?'':Moment(item.reg_datetime).format('YYYY-MM-DD HH:mm:ss')),
                    update_user_id: item.update_user_id,
                    update_user_name: item.update_user_name,
                    update_datetime: (item.update_datetime === undefined?'':Moment(item.update_datetime).format('YYYY-MM-DD HH:mm:ss')),
                    update_flag: PermissionMap[item.authority_id] ? 'Y' : 'N'
                }));
                setOriginRows(response.data);
                setRows([ ...new Set((array).map(JSON.stringify)) ].map(JSON.parse));
            }else{
                appStore.capture();
            }
        })
        .catch((error) => {
            appStore.capture();
        })
        .finally(() => {
            appStore.setLoading(false); 
        });

    }

    const handleInitSelect = () => {
        //권한유형
        var array = [
             {value:'', label:'권한유형'}
            ,{value:'1', label:'계정권한'}
            ,{value:'2', label:'자원권한'}
        ];
        
        //부서
        axios.get('/api/Common/DeptList')
        .then((response) => {
            var array_modal = response.data.map((item, index) => 
                ({ value: item.dept_id, label: item.dept_name })
            );
            setDeptModalOption(array_modal);
            
        })
        .catch((error) => {
            console.log(error);
        });

        //직위, 직책
        axios.get('/api/Common/CodeDetailList')
        .then((response) => {
            var position_array_modal = [];
            var duty_array_modal = [];
            for(let i=0; i<(response.data).length; i++){
                if((response.data)[i].code_id === '0003'){
                    position_array_modal.push({ value: (response.data)[i].code_detail_seq, label: (response.data)[i].code_detail_name });
                }else if((response.data)[i].code_id === '0004'){
                    duty_array_modal.push({ value: (response.data)[i].code_detail_seq, label: (response.data)[i].code_detail_name });
                }
            }
            
            setPositionModalOption(position_array_modal);
            setDutyModalOption(duty_array_modal);
        })
        .catch((error) => {
            console.log(error);
        });

        setAuthorityTypeOption(array);
        setAuthorityTypeModalOption(array);
    }

    const handleInit = () => {
        setKeyword({
            authority_type: 0,
            search: ''
        })
        
        // Hide컬럼 숨기기.
        setColumnVisibilityModel({
            id: false,
            authority_type: false,
            authority_name: true,
            authority_type_name: true,
            authority_desc: true,
            reg_user_id: false,
            reg_user_name: true,
            reg_datetime: true,
            update_user_id: false,
            update_user_name: true,
            update_datetime: true,
            deleted: true,
            updated: true
        });
    };

    const handleReg = () => {
        setRegModalOpen(true);
        setModalTitle('권한 등록');
    };
    
    const UpdateClick = (object) => {
        setUpdateModalOpen(true);
        setModalTitle('권한 수정');
        setSelectAuthorityID(object.row.id);
    };

    const DeleteClick = (object) => {
        Swal.fire({
            title: '권한 '+object.row.authority_name+' 삭제',
            html : '권한 '+object.row.authority_name+'을(를) <span style="color:red; font-weight:bold;">삭제</span> 하시겠습니까?<br/>삭제하시면 복구 할 수 없습니다.',
            showCancelButton : true,
            confirmButtonColor : "#d33",
            confirmButtonText : "삭제",
            cancelButtonText : "닫기"
        }).then((result) => {
            if (result.isConfirmed) {
                if (appStore.loading) return;
                appStore.setLoading(true);

                axios.post('/api/p/Authority/Delete', new URLSearchParams({
                    delete_authority_id: object.row.id
                }),
                { withCredentials: true })
                .then(function (response) {
                    if(response.status === 200){
                        Swal.fire({
                            title: '권한 '+object.row.authority_name+' 삭제 완료',
                            text: '정상적으로 권한 '+object.row.authority_name+'가 삭제 되었습니다.',
                            confirmButtonText: '확인',
                            timer: 5000,
                            timerProgressBar: true
                        }).then((result) => {
                            setRows((rows) => rows.filter((data) => data.id !== object.row.id));
                        });
                    }else{
                        appStore.capture();
                    }
                })
                .catch(function (error) {
                    appStore.capture();
                })
                .finally(() => {
                    appStore.setLoading(false); 
                });
            }
        });
    };

    const onSelectChange = (type, value) => {
        const nextKeyword = {
            ...keyword,
            [type] : value
        };
        setKeyword(nextKeyword);
    };

    const onChange = (e)=>{
        const {name, value} = e.target;
        const nextKeyword = {
            ...keyword,
            [name]: value, 
        };
        setKeyword(nextKeyword);
    };

    const onSubmitSearch = (e) => {
        //입력 검색어는 Enter로 조회.
        if (e.key === "Enter") {
          handleView();
        }
    };

    const handleRegSuccessSave = (regID) => {
        setModalTitle('권한 수정');
        setRegModalOpen(false);
        handleView();

        Swal.fire({
            title: '권한 등록 완료',
            text: '정상적으로 권한이 등록 되었습니다.',
            confirmButtonText: '확인',
            timer: 5000,
            timerProgressBar: true
        }).then((result) => {
            // 수정 화면 불러오기
            setUpdateModalOpen(true);
            setSelectAuthorityID(Number(regID));
        });
    };

    const handleExcel = () => {
        var filename = '권한관리'
        axios.get('/api/p/Authority/Excel',
        {   
            params : { authority_type: keyword.authority_type, search: keyword.search, file_name: filename },
            responseType:'blob'
        },
        { withCredentials: true })
        .then(function (response) {
            
            if(response.status === 200){
                filename = filename + ' ' + appStore.YYYY_MM_DD_HH_MI_SS();
                const link = document.createElement('a');
                link.href = URL.createObjectURL(response.data);
                link.setAttribute('download', filename+'.xlsx');
                document.body.appendChild(link);
                link.click();
            }
        })
        .catch(function (error) {
            appStore.capture();
        })
    };

    return (
        <div style={ { width:'100%', display: String(MenuID) === String(0) ? 'hidden' : 'block' } }>
            <div className="menubox">
                <div className="menu-action">
                    <div className="menu-title">{ MenuName }</div>
                    <div className="menu-button">
                    { MenuUpdateYN === "Y"?
                    <Button 
                        onClick={ handleReg }
                        className="btn-p btn-u"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "#FF3636", 
                            backgroundColor: "#FF3636",
                            ":hover": { boxShadow: "2px 2px 2px #FF3636" , backgroundColor: "#FF3636", borderColor: "#FF3636"}
                        }} 
                        variant="outlined">
                        등록
                    </Button> : <></> }
                    {isRegModalOpen  && MenuUpdateYN === 'Y'&& (
                        <AuthorityRegModal
                            onClose={() => {
                                setRegModalOpen(false);
                            }}
                            title={modalTitle}
                            handleRegSuccessSave={handleRegSuccessSave}
                            authorityTypeModalOption={authorityTypeModalOption}
                            deptModalOption={deptModalOption}
                            positionModalOption={positionModalOption}
                            dutyModalOption={dutyModalOption}
                            MenuUpdateYN={MenuUpdateYN}
                        />
                    )}
                    <Button 
                        onClick={ handleExcel }
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "#00AC47", 
                            backgroundColor: "#00AC47",
                            ":hover": { boxShadow: "2px 2px 2px #00AC47" , backgroundColor: "#00AC47", borderColor: "#00AC47"}
                        }} 
                        variant="outlined">
                        엑셀
                    </Button>
                    <Button 
                        onClick={ handleInit }
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "black", 
                            backgroundColor: "black",
                            ":hover": { boxShadow: "2px 2px 2px black" , backgroundColor: "black", borderColor: "black"}
                        }} 
                        variant="outlined">
                        초기화
                    </Button>
                    <Button 
                        onClick={ handleView }
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "#3D63AE", 
                            backgroundColor: "#3D63AE",
                            ":hover": { boxShadow: "2px 2px 2px #3D63AE" , backgroundColor: "#3D63AE", borderColor: "#3D63AE"}
                        }} 
                        variant="outlined">
                        조회
                    </Button>
                    </div>
                </div>
                <div className="menu-keyword">
                    <div className="menu-keyword-sub">
                        <div className="menu-keyword-sub-title">
                            권한유형
                        </div>
                        <div className="menu-keyword-sub-keyword">
                            <Select className="menu-keyword-sub-keyword-select" placeholder="권한유형" onChange={(e) => onSelectChange('authority_type',e.value)} value={authorityTypeOption.filter(function (option) { return option.value === keyword.authority_type;  })} options={authorityTypeOption} noOptionsMessage={() => "조회되는 항목 없음"} />
                        </div>
                    </div>
                    <div className="menu-keyword-sub">
                        <div className="menu-keyword-sub-keyword" style={ { maxWidth: '300px' } }>
                            <input type="text" placeholder="검색" value={keyword.search} name="search" onChange={(e) => onChange(e) } onKeyPress={onSubmitSearch} autoComplete="off" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="grid">
                <div className="grid_sub" style={ { width: '100%', fontSize: '17px' } }>
                    <DataGrid
                        className="grid_main"
                        rows={rows}
                        columns={columns}
                        slots={{
                            noRowsOverlay: GridNoRow,
                        }}
                        columnVisibilityModel={columnVisibilityModel}
                        AlternatingRowBackground="LavenderBlush"
                        rowsPerPageOptions={[20, 50, 100]}
                    />
                    {isUpdateModalOpen && (
                        <AuthorityUpdateModal
                            onClose={() => {
                                setUpdateModalOpen(false);
                            }}
                            title={modalTitle}
                            id={selectAuthorityID}
                            originRows={originRows.filter(row => String(row.authority_id) === String(selectAuthorityID))}
                            handleView={handleView}
                            authorityTypeModalOption={authorityTypeModalOption}
                            deptModalOption={deptModalOption}
                            positionModalOption={positionModalOption}
                            dutyModalOption={dutyModalOption}
                            MenuUpdateYN={MenuUpdateYN}
                            MenuDeleteYN={MenuDeleteYN}
                        />
                    )}
                </div>
            </div>
        </div>
    )
}

const AppWrap = styled.div`
  text-align: center;
  margin: 50px auto;
`;

export default Authority;
